import { Component, OnInit, ViewChild } from '@angular/core';
import { JournalService } from '../services/journal.service';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-journal',
  templateUrl: './journal.component.html',
  styleUrls: ['./journal.component.scss'],
})
export class JournalComponent implements OnInit {
  isLoading = false;
  journalEntries: any = [];
  page: any;
  pages: any = [
    'prepWell',
    'prepSteps',
    'prepFit',
    'prepStrong',
    'breatheWell',
    'iQuit',
    'drinkGuide',
    'eatWell',
    'sleepWell',
    'feelWell',
  ];
  pageId: any = 'prepWell';
  addEntry = false;
  editEntry: any;
  submitted = false;

  areas = [
    { id: 'prepWell', label: 'General' },
    { id: 'prepSteps', label: 'Prep Steps' },
    { id: 'prepFit', label: 'Prep Fit' },
    { id: 'prepStrong', label: 'Prep Strong' },
    { id: 'breatheWell', label: 'Breathe Well' },
    { id: 'iQuit', label: 'I Quit' },
    { id: 'drinkGuide', label: 'Drink Guide' },
    { id: 'eatWell', label: 'Eat Well' },
    { id: 'sleepWell', label: 'Sleep Well' },
    { id: 'feelWell', label: 'Feel Well' },
  ];

  @ViewChild('entryForm', { static: false }) entryForm?: NgForm;
  @ViewChild('editForm', { static: false }) editForm?: NgForm;

  constructor(private journalService: JournalService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.journalService.fetchAll().subscribe((responseData) => {
      this.journalEntries = responseData;
      this.isLoading = false;
    });

    this.journalService.activeArea.subscribe((area: string) => {
      this.goToPage(area);
    });
  }

  onClose() {
    this.journalService.showJournal.next(false);
  }

  goToPage(pageId: string) {
    this.pageId = pageId;
    this.page = this.pages.indexOf(pageId) + 1;
    this.addEntry = false;
    this.editEntry = undefined;
  }
  onAddForm() {
    this.addEntry = true;
    //this.pageId = '';
  }

  onEditEntry(entry: any) {
    this.editEntry = entry;
    this.addEntry = false;
    //this.pageId = '';
  }

  onSubmitForm() {
    this.journalService
      .create(this.entryForm?.value.area, this.entryForm?.value.notes)
      .subscribe((responseData) => {
        window.scroll(0, 0);
        this.submitted = true;

        // refresh it
        Swal.fire({
          icon: 'success',
          title: 'Entry Added',
          text: 'Your entry was added',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });

        this.journalService.fetchAll().subscribe((responseData) => {
          this.journalEntries = responseData;
          this.goToPage(this.entryForm?.value.area);
          this.addEntry = false;
        });
      });
  }

  onSubmitEditForm() {
    this.journalService
      .update(
        this.editEntry.user_journal_id,
        this.editForm?.value.area,
        this.editForm?.value.notes
      )
      .subscribe((responseData) => {
        window.scroll(0, 0);
        this.submitted = true;

        // refresh it
        Swal.fire({
          icon: 'success',
          title: 'Entry updated',
          text: 'Your entry was updated',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });

        this.journalService.fetchAll().subscribe((responseData) => {
          this.journalEntries = responseData;
          this.goToPage(this.editForm?.value.area);
          this.addEntry = false;
          this.editEntry = undefined;
        });
      });
  }

  getNotes(area: string) {
    let filteredArray = this.journalEntries.filter((itm: any) => {
      return itm.area == area;
    });
    return filteredArray;
  }

  onDelete(entry: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to undo this",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.journalService
          .delete(entry.user_journal_id)
          .subscribe((responseData) => {
            window.scroll(0, 0);
            this.submitted = true;

            // refresh it
            Swal.fire({
              icon: 'success',
              title: 'Entry deleted',
              text: 'Your entry was deleted',
              showConfirmButton: false,
              timer: 1000,
              timerProgressBar: true,
            });

            this.journalService.fetchAll().subscribe((responseData) => {
              this.journalEntries = responseData;
              this.goToPage(entry.area);
              this.addEntry = false;
              this.editEntry = undefined;
            });
          });
      }
    });
  }
}
